import isUndefined from 'lodash/isUndefined'
import { serializeSwrKey } from './cache-key'

/**
 * @see https://github.com/vercel/swr/blob/1.3.0/src/use-swr.ts#L78
 * @see https://github.com/vercel/swr/blob/v2.1.1/core/use-swr.ts#L187
 * Get the current state that SWR should return.
 */
export const getCurrentStateThatSWRShouldReturn = ({ key, config }) => {
	const { cache, fallbackData } = config
	const _key = serializeSwrKey(key)

	const cacheData = cache.get(_key)?.data
	const fallback = isUndefined(fallbackData) ? config.fallback[_key] : fallbackData
	const state = isUndefined(cacheData) ? fallback : cacheData

	return state
}
